import gql from 'graphql-tag'

export default gql`
query getBusiness(
  $endpointId: String
  $appointmentId: ID
  $token: String
) {
  endpoint: getEndpoint(
    endpointId: $endpointId
    appointmentId: $appointmentId
  ){
    resourceType
    resourceId
    hasAvailableTimes
  },
  business: getBusiness(
    endpointId: $endpointId
    appointmentId: $appointmentId
  ),
  appointment: getAppointment(
    id: $appointmentId
    token: $token
  ) {
    id
    business
    service
    staff
    customer
    duration
    price
    date
    currency
    clientTimezone
    hangoutLink
    found
    token
    tokenError
    locationValue
    locationType
    hasMoreOccurrences
    noOcurrences
    originalDate
    adHocService
    answers
  }
}
`
